import apiFetch from '../apiFetch'

export default function (idDireccionCliente, token) {
  return apiFetch({endPoint: `Combos/getComboRutasDireccionClienteActivas?idDireccionCliente=` + idDireccionCliente, method: 'GET', body: null, token: token})
}